module.exports = __webpack_public_path__ + "static/img/plus.00cd6bc8.svg";